import React from 'react';
import Header from '../../Header';
import Footer from '../../Footer';
import ActivityNavigation from './ActivityNavigation';
import './ActivityShared.css';

/**
 * Common layout component for all activities
 * @param {Object} props - Component props
 * @param {string} props.title - Activity title
 * @param {React.ReactNode} props.children - Child components
 * @param {Function} props.onLogout - Logout handler
 * @param {Function} props.onCourseSelect - Course selection handler
 * @param {boolean} props.showFooter - Whether to show footer (default: true)
 * @returns {JSX.Element} Activity layout component
 */
const ActivityLayout = ({ 
  title, 
  children, 
  onLogout, 
  onCourseSelect, 
  showFooter = true 
}) => {
  return (
    <div className="activity-page">
      <ActivityNavigation 
        onLogout={onLogout} 
        onCourseSelect={onCourseSelect} 
      />
      
      <Header title={title} />
      
      <div className="activity-content">
        {children}
      </div>
      
      {showFooter && <Footer />}
    </div>
  );
};

export default ActivityLayout;
